import React from 'react';
import { componentService } from 'js/services/component.service';

export const DynamicChangeDetails = React.lazy(() => import(/* webpackChunkName: "dynamic-change-details" */ './DynamicChangeDetails'));

componentService.registerPageComponents({ 'dynamic-change-details': DynamicChangeDetails });
// <hub2-dynamic-change-details config="{'formName': 'formName'}"></hub2-dynamic-change-details>
componentService.registerWebContentComponents({ DynamicChangeDetails });
